module.exports = __webpack_public_path__ + "mo/img/piece-17.a519856b.svg";